import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Movie } from '../shared/movie.model'

@Component({
    moduleId: module.id,
    selector: 'cm-movie-list',
    templateUrl: 'movie-list.component.html',
    styleUrls: [ './movie-list.component.css' ]
})
export class MovieListComponent implements OnInit {

    @Input() movies: Movie[]
    @Output() selectMovie = new EventEmitter()

    constructor() { }

    ngOnInit() {
    }

    onSelectMovie(movie: any, selected: boolean) {
        this.selectMovie.emit({
            movie: movie,
            selected: selected
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-list/movie-list.component.ts